<script setup lang="ts">
import type { Locale } from "~ui/utils/locales"
import type { DropdownMenuContentProps } from "reka-ui"
import { LocaleFlag } from "#components"

const locale = defineModel<Locale>()

const {
  locales = [
    "da_DK",
    "en_US",
    "de_DE",
    "nb_NO",
    "sv_SE",
    "pt_PT",
    "fi_FI",
    "pl_PL",
    "es_ES",
    "fr_FR",
  ],
} = defineProps<{
  locales?: Locale[]
  popoverSide?: DropdownMenuContentProps["side"]
}>()

defineEmits(["open"])

const localeMap = {
  es_ES: "spanish",
  fr_FR: "french",
  da_DK: "danish",
  en_US: "english",
  de_DE: "german",
  nb_NO: "norwegian",
  sv_SE: "swedish",
  pt_PT: "portugese",
  fi_FI: "finnish",
  pl_PL: "polish",
  nl_NL: "dutch",
}
</script>

<template>
  <DropdownMenu :class="$attrs.class" @open="$emit('open')">
    <DropdownTrigger class="w-full">
      <slot>
        <FormButton
          data-testid="locale_switcher"
          variant="secondary"
          :class="$attrs.class"
        >
          <span class="block pr-4 text-left text-sm font-medium">
            {{
              locale ? $t(`locale.${localeMap[locale]}`) : $t("locale.current")
            }}
          </span>
          <LocaleFlag v-if="locale" :locale />
        </FormButton>
      </slot>
    </DropdownTrigger>
    <DropdownContent :side="popoverSide">
      <DropdownItem v-for="loc in locales" :key="loc" @select="locale = loc">
        <LocaleFlag :locale="loc" />
        {{ $t(`locale.${localeMap[loc]}`) }}
      </DropdownItem>
    </DropdownContent>
  </DropdownMenu>
</template>
